// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"5595ab85","367":"a9f8a3a2","684":"c7deae25","945":"4fc9be19","953":"5357ccd0"}[chunkId] + ".chunk.js";
};